<script>
export default {
  name: "upload-file-button",
  props: {
    size: {
      type: String,
      default: "md"
    },
    serverUri: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    uploadModal() {
      $(this.$refs.myfile).click()
    },
    async uploadHandler() {
      let data = new FormData();
      data.append("file", $(this.$refs.myfile)[0].files[0]);
      for (let key in this.data) {
        data.append(key, this.data[key]);
      }

      try {
        const {data} =await axios.post(this.serverUri, data, {"Content-Type": "multipart/form-data"})

        this.$vs.notify({
          title: 'Archivo subido',
          text: 'El archivo se ha subido correctamente',
          color: 'success'
        });

        this.$emit('on-file-uploaded', data);
      } catch (err) {
        this.$vs.notify({
          title: 'Error',
          text: 'Ocurrió un error al subir el archivo',
          color: 'danger'
        });
        this.$emit('on-file-failed', {
          error: err
        });
      }
    }
  }
}
</script>

<template>
  <div>
  <input
      type="file"
      name="myfile"
      accept="application/xml"
      style="display:none;"
      @change="uploadHandler()" ref="myfile">

  <vs-button
      :size="size"
      @click="uploadModal()"
      color="dark" icon="upload">
    <slot></slot>
  </vs-button>
  </div>
</template>

<style scoped>

</style>